import React from 'react';
import { FormControl, TextField, InputLabel, Input, FormHelperText, RadioGroup, FormControlLabel, Radio, Container, Grid, Paper, Toolbar, Box } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useLocation } from 'react-router-dom';
import SectionE from '../../../NewJoineForm/SectionE';

function AdminSectionE(props) {
    const  location = useLocation();
    const id = location.state.id;
    

    return (
        <div>
            <div className='d-flex'>
                <Box
                    component="main"
                    sx={{
                        backgroundColor: (theme) =>
                            theme.palette.mode === 'light'
                                ? theme.palette.grey[100]
                                : theme.palette.grey[900],
                        flexGrow: 1,
                        width: " 100%",
                        // height: '100vh',
                        overflowX: 'hidden',
                    }}
                >
                    <Toolbar />
                    <div className='row px-4 py-3'>
                        <div className='col-lg-1 mx-3'></div>
                        <div style={{ cursor: "pointer" }} className='col-lg-10 ps-5 fs-5'> <ArrowBackIcon sx={{ cursor: "pointer", paddingRight: "3px" }} fontSize='medium' />Back</div>
                    </div>
                    <div className='d-flex'>
                        <div className='col-12 bg-white'>
                            <SectionE id={id}/>
                        </div>
                    </div>
                </Box>
            </div>
        </div>
    );
}

export default AdminSectionE;